module.exports = __webpack_public_path__ + "static/media/headerSearchLight.90770942.svg";